<nav class="navbar fixed-top">
  <div class="d-flex align-items-center navbar-left">
    <a (click)="menuButtonClick($event, sidebar.menuClickCount, sidebar.containerClassnames); false;"
      href="javascript:;" class="menu-button d-none d-md-block">
      <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
        <rect x="0.48" y="0.5" width="7" height="1" />
        <rect x="0.48" y="7.5" width="7" height="1" />
        <rect x="0.48" y="15.5" width="7" height="1" />
      </svg> {{" "}}
      <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
        <rect x="1.56" y="0.5" width="16" height="1" />
        <rect x="1.56" y="7.5" width="16" height="1" />
        <rect x="1.56" y="15.5" width="16" height="1" />
      </svg>
    </a>

    <a (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)" href="javascript:;"
      class="menu-button-mobile d-xs-block d-sm-block d-md-none">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
        <rect x="0.5" y="0.5" width="25" height="1" />
        <rect x="0.5" y="7.5" width="25" height="1" />
        <rect x="0.5" y="15.5" width="25" height="1" />
      </svg>
    </a>

    <div class="search" (click)="searchAreaClick($event)" style="display: none;">
      <input placeholder="Search..." [(ngModel)]="searchKey" (keyup)="searchKeyUp($event)">
      <span class="search-icon" (click)="searchClick($event)">
        <i class="simple-icon-magnifier"></i>
      </span>
    </div>

    <div class="btn-group ml-2" dropdown *ngIf="!isSingleLang" style="display: none;">
      <button dropdownToggle type="button" class="language-button dropdown-toggle btn btn-light btn-sm">
        {{currentLanguage | uppercase}} <span class="caret"></span>
      </button>
      <ul *dropdownMenu class="dropdown-menu" role="menu">
        <li role="menuitem" *ngFor="let item of languages" (click)="onLanguageChange(item)"><a class="dropdown-item"
            href="javascript:;">{{item.label}}</a></li>
      </ul>
    </div>
<!-- 
    <a class="btn btn-sm btn-outline-primary ml-2 d-none d-xl-inline-block" style="display: none;" href="https://1.envato.market/6NV1b"
      target="_blank">&nbsp;BUY&nbsp;</a> -->
  </div>

  <a *ngIf="!uploadedImg" class="navbar-logo" routerLink="/app/dashboards/default" >
    <span class="logo d-none d-xs-block"></span>
    <span class="logo-mobile d-block d-xs-none"></span>
  </a>

  <div *ngIf="uploadedImg"  class="navbar-logo" >
    <img class="logo"  src="{{uploadedImg}}" alt="identityproofid" routerLink="/app/dashboards/default">
  </div>

  <div class="navbar-right">
    <div class="header-icons d-inline-block align-middle">

      <!-- <div class="d-none d-md-inline-block align-text-bottom mr-1">
        <div class="custom-control custom-switch" tooltip="Dark Mode" placement="left">
          <input type="checkbox" class="custom-control-input" id="darkModeSwitch" [checked]="isDarkModeActive"
            (change)="onDarkModeChange($event)">
          <label class="custom-control-label" for="darkModeSwitch"></label>
        </div>
      </div> -->

      <div class="position-relative d-none d-sm-inline-block">
        <div dropdown>
          <button dropdownToggle type="button" class="header-icon btn btn-empty" style="display: none;">
            <i class="simple-icon-grid"></i>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-menu-right mt-3" role="menu" aria-labelledby="button-basic"
            id="iconMenuDropdown">
            <a href="javascript:;" class="icon-menu-item">
              <i class="iconsminds-equalizer d-block"></i>
              <span>Settings</span>
            </a>

            <a href="javascript:;" class="icon-menu-item">
              <i class="iconsminds-male-female d-block"></i>
              <span>Users</span>
            </a>

            <a href="javascript:;" class="icon-menu-item">
              <i class="iconsminds-puzzle d-block"></i>
              <span>Components</span>
            </a>

            <a href="javascript:;" class="icon-menu-item">
              <i class="iconsminds-bar-chart-4 d-block"></i>
              <span>Profits</span>
            </a>

            <a href="javascript:;" class="icon-menu-item">
              <i class="iconsminds-file d-block"></i>
              <span>Surveys</span>
            </a>

            <a href="javascript:;" class="icon-menu-item">
              <i class="iconsminds-suitcase d-block"></i>
              <span>Tasks</span>
            </a>
          </div>
        </div>
      </div>

      <div class="position-relative d-inline-block">

        <!-- <div dropdown>
          <button id="button-basic" dropdownToggle type="button" id="notificationButton"
            class="header-icon btn btn-empty" >
            <i class="simple-icon-bell" style="font-size: 1.5em;" (click)="Notification()"></i>
            <span class="count">{{totalcount}}</span>
          </button> -->


          <div dropdown>
            <button id="button-basic" dropdownToggle type="button" id="notificationButton"
              class="header-icon btn btn-empty" >
              <i class="simple-icon-bell" style="font-size: 1.5em;" (click)="toggledown($event)"></i>
              <span class="count">{{totalcount}}</span>
            </button>

          <!-- <div dropdown>
            <button id="button-basic" dropdownToggle type="button" id="notificationButton"
              class="header-icon btn btn-empty" >
              <i class="simple-icon-bell" style="font-size: 1.5em;" (click)="Notification($event)"></i>
              <span class="count">{{totalcount}}</span>
            </button> -->

          <!-- <div dropdown [autoClose]="'outside'">
            <button id="button-basic" dropdownToggle type="button" id="notificationButton"
              class="header-icon btn btn-empty" >
              <i class="simple-icon-bell" style="font-size: 1.5em;" (click)="Notification()"></i>
              <span class="count">{{totalcount}}</span>
            </button> -->


            <!-- <div dropdown #notificationDropdown="bs-dropdown" [autoClose]="'outside'">
              <button 
                id="notificationButton"
                dropdownToggle 
                type="button"
                class="header-icon btn btn-empty position-relative"
                (click)="Notification(notificationDropdown)"

              >
                <i class="simple-icon-bell" style="font-size: 1.5em;"></i>
                <span class="count">{{ totalcount }}</span>
              </button> -->
            
              <!-- <div *dropdownMenu class="dropdown-menu dropdown-menu-end mt-2">
                <div class="dropdown-item">Notification 1</div>
                <div class="dropdown-item">Notification 2</div>
              </div> -->
            <!-- </div> -->
            
          

          <!-- <div dropdown container="body" [autoClose]="'outside'">
            <button 
              id="button-basic"
              dropdownToggle 
              type="button"
              class="header-icon btn btn-empty"
            >
              <i class="simple-icon-bell" style="font-size: 1.5em;" (click)="Notification()"></i>
              <span class="count">{{ totalcount }}</span>
            </button> -->
          
            <!-- <div *dropdownMenu class="dropdown-menu dropdown-menu-end mt-2">
              <div class="dropdown-item">Notification 1</div>
              <div class="dropdown-item">Notification 2</div>
            </div> -->


          <!-- <div dropdown container="body" [autoClose]="'outside'">
            <button 
              id="notificationButton"
              dropdownToggle 
              type="button"
              class="header-icon btn btn-empty position-relative"
            >
              <i class="simple-icon-bell" style="font-size: 1.5em;"></i>
              <span class="count">{{ totalcount }}</span>
            </button>
          
            <div *dropdownMenu class="dropdown-menu dropdown-menu-end mt-2">
              <div class="dropdown-item">Notification 1</div>
              <div class="dropdown-item">Notification 2</div>
            </div> -->
          <!-- </div> -->
          
          
          

          <!-- <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right mt-3"
            id="notificationDropdown"
            style="width: 464px !important; height: 187px!important;">
            <perfect-scrollbar>
              <div class="d-flex flex-row mb-3 pb-3 border-bottom" *ngFor="let support of supports">
                <a href="javascript:;">
                    <img [src]="support.profilePath==null?'/assets/img/profile-pic-l.jpg':support.profilePath" alt="Notification Image"
                    class="img-thumbnail list-thumbnail xsmall border-0 rounded-circle" />
                </a> 
                <div class="pl-3">
                  <a href="javascript:;" (click)="OpenNotification(support.id,support.ticketId)">
                    <p class="font-weight-medium mb-1">{{support.subject}}</p>
                    <p class="text-muted mb-0 text-small">{{support.date}} - {{support.time}}</p>
                  </a>
                </div>
              </div>
              </perfect-scrollbar>
          </div> -->


          <div id="dropdown-basic" *ngIf="notificationDropDown"  class="dropdown-menu dropdown-menu-right mt-3"
            id="notificationDropdown"
            style="width: 464px !important; height: 187px!important;">
            <perfect-scrollbar>
              <div class="d-flex flex-row mb-3 pb-3 border-bottom" *ngFor="let support of supports">
                <a href="javascript:;">
                  <!-- <div class="profile-card__avatar" style=" background-image: url({{ support.profilePath == null ? 'assets/img/profile-pic-l.jpg' :support.profilePath }}); width: 65px;height: 65px;background-position: center;background-size: cover;border-radius: 50px">
              
                  </div> -->
                  <!-- <img [src]="support.profilePath==null?'/assets/img/profile-pic-l.jpg':support.profilePath" alt="Notification Image"
                    class="img-thumbnail list-thumbnail xsmall border-0 rounded-circle" /> -->
                </a> 
                <div class="pl-3">
                  <a href="javascript:;" (click)="OpenNotification(support.id,support.ticketId)">
                    <p class="font-weight-medium mb-1">{{support.subject}}</p>
                    <p class="text-muted mb-0 text-small">{{support.date}} - {{support.time}}</p>
                  </a>
                </div>
              </div>
              <!-- <div class="d-flex flex-row mb-3 pb-3 border-bottom">
                <a href="javascript:;">
                  <img src="/assets/img/notification-thumb.jpg" alt="Notification Image"
                    class="img-thumbnail list-thumbnail xsmall border-0 rounded-circle" />
                </a>
                <div class="pl-3">
                  <a href="javascript:;">
                    <p class="font-weight-medium mb-1">1 item is out of stock!</p>
                    <p class="text-muted mb-0 text-small">09.04.2018 - 12:45</p>
                  </a>
                </div>
              </div>
              <div class="d-flex flex-row mb-3 pb-3 border-bottom">
                <a href="javascript:;">
                  <img src="/assets/img/notification-thumb-2.jpg" alt="Notification Image"
                    class="img-thumbnail list-thumbnail xsmall border-0 rounded-circle" />
                </a>
                <div class="pl-3">
                  <a href="javascript:;">
                    <p class="font-weight-medium mb-1">New order received! It is total $147,20.</p>
                    <p class="text-muted mb-0 text-small">09.04.2018 - 12:45</p>
                  </a>
                </div>
              </div>
              <div class="d-flex flex-row mb-3 pb-3 ">
                <a href="javascript:;">
                  <img src="/assets/img/notification-thumb-3.jpg" alt="Notification Image"
                    class="img-thumbnail list-thumbnail xsmall border-0 rounded-circle" />
                </a>
                <div class="pl-3">
                  <a href="javascript:;">
                    <p class="font-weight-medium mb-1">3 items just added to wish list by a user!
                    </p>
                    <p class="text-muted mb-0 text-small">09.04.2018 - 12:45</p>
                  </a>
                </div>
              </div> -->
            </perfect-scrollbar>
          </div>

        </div>


      </div>

   
<!-- 
      <i class="simple-icon-user" style="font-size: 1.2em; "></i>
      <span style="text-transform: capitalize;" class="name">{{displayName}}</span>
 -->



 <!-- <div style="display: inline-flex; align-items: center; padding: 4px 10px; border: 2px solid #5a638f; border-radius: 999px; background-color: #f9f9f9;">
  <i class="simple-icon-user" style="font-size: 1.2em; margin-right: 6px;"></i>
  <span style="text-transform: capitalize; font-size: 0.9em; color: #333;" class="name">{{ displayName }}</span>
</div> -->





<div style="position: relative; display: inline-flex; align-items: center;">
 
  <div
    (click)="toggleDropdown()"
    style="display: inline-flex; align-items: center; padding: 5px ;  background-color: #f9f9f9; cursor: pointer;"
  >
  <!-- <span>
    <i class="simple-icon-user" style="font-size: 1.2em; margin-right: 6px;" ></i>
    </span> -->
    <span style="text-transform: capitalize; font-size: 0.9em; color: #333;" class="name">
      <i class="simple-icon-user" style="font-size: 1.5em" ></i> 
    </span>
  </div>

  <!-- <div *ngIf="isDropdownOpen" class="dropdown-menu">
    <p style="margin: 0 0 6px; font-size: 1.1em; cursor: default; color: #555;">
     Welcome
     
      <span style="font-weight: bold; color: #333;">{{ displayName }}</span>
    </p>
  
    <hr style="margin: 8px 0; border: 0; border-top: 1px solid #e0e0e0;" />

    <p style="margin: 0; font-size: 1.2em; cursor: pointer; color: #5a638f;" (click)="changePassword()">
      <i class="simple-icon-lock" style="font-size: 1.2em; margin-right: 6px;"></i>
      Change Password
    </p>

    <hr style="margin: 8px 0; border: 0; border-top: 1px solid #e0e0e0;" />

  
    <p style="margin: 0 6px 6px 0; font-size: 1.2em; cursor: pointer; color: #d9534f;" (click)="logout()">
      <i class="simple-icon-logout" style="font-size: 1.2em; margin-right: 6px; transform: scaleX(-1);"></i>
      Logout
    </p>
  
   
  </div> -->
  

  <div *ngIf="isDropdownOpen" class="dropdown-menu">
    <p class="menu-item1" style="margin: 0 0 0px; font-size: 1.1em; cursor: default;">
      Welcome
      <span style="font-weight: bold; ">{{ displayName }}</span>
    </p>
  
    <hr style="margin: 0px 0; border: 0; border-top: 1px solid #e0e0e0;" />
  
    <p class="menu-item" (click)="changePassword()">
      <i class="simple-icon-lock" style="font-size: 1.2em; margin-right: 6px;"></i>
      Change Password
    </p>
  
    <hr style="margin: 0px 0; border: 0; border-top: 1px solid #e0e0e0;" />
  
    <p class="menu-item" (click)="logout()">
      <i class="simple-icon-logout" style="font-size: 1.2em; margin-right: 6px; transform: scaleX(-1);"></i>
      Logout
    </p>
  </div>

  
</div>

      
    

      <!-- <button class="header-icon btn btn-empty d-none d-sm-inline-block" type="button" style="display: none;" id="fullScreenButton"
        (click)="fullScreenClick()">
        <i *ngIf="!isFullScreen" class="simple-icon-size-fullscreen"></i>
        <i *ngIf="isFullScreen" class="simple-icon-size-actual"></i>
      </button> -->

    </div>

    <div class="user d-inline-block" dropdown>
      <button class="btn btn-empty p-0" type="button" dropdownToggle>
          <div class="profile-card__avatar" >
          <!-- style=" background-image: url({{ profilepath == null ? 'assets/img/profile-pic-l.jpg' :profilepath }}); width: 38px;height: 38px;background-position: center;background-size: cover;border-radius: 50px" -->
          </div>
          <!-- <img alt="Profile Picture" [src]="profilepath" /> -->
       
      </button>

      <div class="dropdown-menu dropdown-menu-right mt-3" *dropdownMenu role="menu">
        <a class="dropdown-item c-pointer" (click)="EditProfile()">Account</a>
        <!-- <a class="dropdown-item c-pointer">Features</a>
        <a class="dropdown-item c-pointer">History</a>
        <a class="dropdown-item c-pointer">Support</a> -->
        <li class="divider dropdown-divider"></li>
        <a class="dropdown-item c-pointer" (click)="onSignOut()">Sign out</a>
      </div>
    </div>

  </div>
</nav>
